import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import LanguageIcon from '@material-ui/icons/Language'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import {
  PROFILE_SOCIAL_PLATFORMS,
  ProfileSocialLink,
  ProfileSocialPlatformKey,
  getProfileSocialPlatform,
} from '../../../constants'
import { styles } from './styles'

interface SocialLinkRowProps {
  link: ProfileSocialLink
  onChange: (link: ProfileSocialLink) => void
  onRemove: () => void
  canRemove: boolean
  error?: string
  t: TFunction
}

const PlatformIcon = ({
  logo,
  label,
  className,
}: {
  logo?: string
  label: string
  className: string
}) => {
  if (logo) {
    return <img src={logo} alt={label} className={className} />
  }
  return <LanguageIcon className={className} />
}

const SocialLinkRow = ({
  link,
  onChange,
  onRemove,
  error,
  t,
}: SocialLinkRowProps) => {
  const classes = styles()
  const platform = getProfileSocialPlatform(link.platform)

  const handlePlatformChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>
  ) => {
    onChange({
      ...link,
      platform: event.target.value as ProfileSocialPlatformKey,
    })
  }

  return (
    <div className={classes.row}>
      <div className={classes.rowInner}>
        <FormControl variant="outlined" className={classes.platformSelect}>
          <Select
            value={link.platform}
            onChange={handlePlatformChange}
            displayEmpty
            IconComponent={KeyboardArrowDownIcon}
            MenuProps={{
              anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
              transformOrigin: { vertical: 'top', horizontal: 'left' },
              getContentAnchorEl: null,
            }}
            renderValue={value => {
              const selected = getProfileSocialPlatform(
                value as ProfileSocialPlatformKey
              )
              return (
                <span className={classes.selectValue}>
                  <PlatformIcon
                    logo={selected.logo}
                    label={selected.label}
                    className={classes.platformIcon}
                  />
                </span>
              )
            }}
          >
            {PROFILE_SOCIAL_PLATFORMS.map(option => (
              <MenuItem key={option.key} value={option.key}>
                <span className={classes.menuItem}>
                  <PlatformIcon
                    logo={option.logo}
                    label={option.label}
                    className={classes.platformIcon}
                  />
                </span>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <input
          className={classes.input}
          type="text"
          value={link.url}
          placeholder={platform.placeholder}
          onChange={event => onChange({ ...link, url: event.target.value })}
        />

        <button
          type="button"
          className={classes.deleteButton}
          onClick={onRemove}
          aria-label={t('shoppingBoard.removeSocialLink')}
        >
          <DeleteOutlineIcon />
        </button>
      </div>
      {error && <p className={classes.fieldError}>{error}</p>}
    </div>
  )
}

export default withTranslation()(SocialLinkRow)
